/**
 * Light Lexical plugin reserved for swatch → selection styling.
 *
 * v3.0: stub. Real swatch → operation merging happens in the operation panels
 * via the StudioRequestContext pattern (shared with Image Lab). v3.0.1 will
 * register a STYLIZE_SELECTION command here that applies a swatch's voice/tone
 * to the current selection and dispatches a Stylize op.
 */
export const SwatchInjectionPlugin: React.FC = () => {
  return null;
};
